import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { StateService } from './state.service';
import { map, Observable, skipWhile } from 'rxjs';
import { Injectable } from '@angular/core';
import { pagesPATH } from '../models_new/config/pages';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionGuard {
  constructor(private stateService: StateService, private router: Router) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot
  ): Observable<any> {
    return this.stateService.getCustomerOrSalesOrganization().pipe(
      skipWhile((org) => !org),
      map((organization) => {
        if (!organization) {
          return false;
        }
        return organization.valid_sub
          ? true
          : this.router.navigate([`/${pagesPATH.SUBSCRIPTION_BLOCK}`]);
      })
    );
  }
}
